import { Link, NavLink, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header className={`site-header ${isHome ? "header-dark" : "header-light"}`}>
      <Link className="brand" to="/" aria-label="Ligentway home">
        <span className="brand-mark">L</span>
        <span>ligentway<span className="brand-dot">.</span></span>
      </Link>
      <nav className="main-nav" aria-label="Main navigation">
        <NavLink to="/services">Services</NavLink>
        <NavLink to="/case-studies">Case studies</NavLink>
        <NavLink to="/insights">Insights</NavLink>
        <NavLink to="/philosophy">Approach</NavLink>
      </nav>
      <Link className="nav-cta" to="/contact">Start a conversation <span>↗</span></Link>
    </header>
  );
}

export default Header;
